import { Component, Prop, h, Host } from '@stencil/core';
import tippy from 'tippy.js';

@Component({
  tag: 'ugc-tooltip',
  styleUrl: 'ugc-tooltip.scss',
  shadow: false,
})
export class UgcTooltip {
  @Prop() name: string = '';
  @Prop() content: string = '';
  @Prop() interactive?: boolean = false;

  componentDidRender() {
    if (!this.content) return;
    tippy(`.ugc-tooltip-${this.name}`, {
      content: `${this.content}`,
      appendTo: () => document.body,
      placement: 'bottom',
      arrow: true,
      theme: 'white',
      allowHTML: true,
      maxWidth: 318,
      interactive: this.interactive,
      zIndex: 99999,
      aria: {
        content: null,
        expanded: false,
      },
    });
  }

  render() {
    return (
      <Host>
        <div class={`flex-row-center-center ugc-tooltip-${this.name}`}>
          <slot />
        </div>
      </Host>
    );
  }
}
